import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "report" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "jumbotron" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h1", { class: "display-4" }, "Thank you!"),
    /*#__PURE__*/_createElementVNode("p", { class: "lead" }, " Thank you for confirming. We have made a note of your response and we will process the appointment accordingly ")
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

import { onMounted, inject } from 'vue';
import { useRoute } from 'vue-router';
import Ably from "ably";

export default /*#__PURE__*/_defineComponent({
  __name: 'SMSConfirmationResponse',
  setup(__props) {

const route = useRoute();
const realtime: Ably.Realtime = inject('realtime');
const actProperty: any = inject('actProperty');
const channel = realtime.channels.get('diary');
const deviceid = actProperty.getDeviceId();

// onMounted(() => {
//     if (route.params.bookingid) {
//         channel.publish('bookingConfirmResponse', {deviceid: deviceid, bookingid: route.params.bookingid});
//     }
// });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}
}

})